// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 372 ? "soundwave" : chunkId) + "-legacy." + {"132":"e9df2f07","372":"7ea4c2bd","941":"7c1b6cac"}[chunkId] + ".js";
};